import React from "react"
import { baseUrlImg } from "../../config/api"

function FallbackTicket({ arr }) {
  const ticketData = arr?.arr || arr

  const renderFallbackTicket = (arr) => {
    const logoHtml =
      arr.service_type === "credit/debit" || arr.receipt.trim().startsWith("<img")
        ? ""
        : `
      <div style="text-align: center; margin-bottom: 20px">
        <img 
          src="${baseUrlImg}/${arr.logo}" 
          alt="service logo" 
          class="service-logo" 
          style="display: inline-block; height: 50px; width: 200px"
        />
      </div>
    `
    const receiptHtml = getFormattedReceiptHtml(arr)

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `${logoHtml}${receiptHtml}`,
        }}
      />
    )
  }

  const getFormattedReceiptHtml = (arr) => {
    let receiptText = arr?.receipt || ""

    // Basic cleanup
    receiptText = receiptText
      .replace(/\\\//g, "/")
      .replace(/\\\\/g, "/")
      .replace(/\\"/g, '"')
      .replace(/\\u20ac/g, "€")
      .replace(/^[\s"]+|[\s"]+$/g, "")
      .replace(/font-size:\s*[^;"]+;?/gi, "")
      .replace(/<\/div>(?=\S)/g, "</div>\n")
      .replace(/<\/b>(?=\S)/g, "</b>\n")

    receiptText = receiptText.replace(/\\u[\dA-F]{4}/gi, (m) =>
      String.fromCharCode(parseInt(m.replace("\\u", ""), 16)),
    )

    receiptText = receiptText.replace(
      /(https?:\/\/[^\s<]+|www\.[^\s<]+)-\s*\n\s*([^\s<]+)/gi,
      "$1-$2",
    )

    // Normalize <a> links
    receiptText = receiptText.replace(
      /<a\s+[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (_m, href, inner) => {
        let cleanHref = href.replace(/\\|<[^>]+>/g, "").trim()
        if (!/^https?:\/\//i.test(cleanHref)) {
          cleanHref = cleanHref.replace(/^https?:/i, "")
          cleanHref = "https://" + cleanHref.replace(/^\/+/, "")
        }
        const cleanText = inner.replace(/<[^>]+>/g, "").trim()
        return `<a href="${cleanHref}" target="_blank">${cleanText}</a>`
      },
    )

    // Extract images
    let imageBlock = ""
    receiptText = receiptText.replace(/<img\s+src="([^"]+)"[^>]*>/gi, (_m, src) => {
      imageBlock = `<div style="display:flex;justify-content:center;margin:20px 0;">
      <img src="${src}" style="max-width:150px;height:auto;"/>
    </div>`
      return ""
    })

    const lines = receiptText.split("\n").flatMap((line) => {
      line = line.trim()
      if (!line) return []

      const divMatches = [...line.matchAll(/<div[^>]*>(.*?)<\/div>/g)]
      if (divMatches.length) return divMatches.map((m) => m[1].trim())

      return [line]
    })

    // ------------------------
    // Linkify raw URLs
    // ------------------------
    const linkify = (text) => {
      if (!text) return ""

      // Step 1: skip already valid <a> tags
      const placeholder = []
      text = text.replace(/<a\s+[^>]*>.*?<\/a>/gi, (m) => {
        placeholder.push(m)
        return `%%A_LINK_${placeholder.length - 1}%%`
      })

      // Step 2: wrap raw URLs in <a> tags
      text = text.replace(/(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi, (url) => {
        let href = url
        if (!/^https?:\/\//i.test(href)) href = "https://" + href
        return `<a href="${href}" target="_blank">${url}</a>`
      })

      // Step 3: restore original <a> tags
      text = text.replace(/%%A_LINK_(\d+)%%/g, (_m, idx) => placeholder[idx])

      return text
    }

    const formattedReceipt = lines
      .map((line) => {
        if (!line) return ""

        const divMatch = line.match(/<div[^>]*>([\s\S]*?)<\/div>/i)
        if (divMatch) line = line.replace(divMatch[0], divMatch[1].trim())

        if (/(https?:\/\/|www\.)/i.test(line)) {
          return `<div style="margin:7px 0;font-size:14px;word-break:break-word;overflow-wrap:anywhere;">
      ${linkify(line)}
    </div>`
        }

        // Match Label: Value, allow any content after colon
        const labelValueMatch = line.match(/^([\w\sÀ-ÖØ-öø-ÿ]+):\s*(.*)$/)
        if (labelValueMatch) {
          const [, label, value] = labelValueMatch
          return `
<div style="display:flex;justify-content:space-between;margin:7px 0;font-size:14px;border-bottom:1px dashed;padding-bottom:2px;">
  <span>${label.trim()}:</span>
  <span style="word-break:break-word;overflow-wrap:anywhere;">${linkify(
    value.trim(),
  )}</span>
</div>`
        }

        // Bold <b>Label:Value</b>
        const boldMatch = line.match(/<b>([^<:]+):([^<]+)<\/b>/i)
        if (boldMatch) {
          const [, label, value] = boldMatch
          return `
<div style="display:flex;justify-content:space-between;margin:7px 0;font-size:14px;border-bottom:1px dashed;padding-bottom:2px;">
  <span>${label.trim()}:</span>
  <span style="word-break:break-word;overflow-wrap:anywhere;">${linkify(
    value.trim(),
  )}</span>
</div>`
        }

        // Otherwise plain text
        return `<div style="margin:7px 0;font-size:14px;word-break:break-word;overflow-wrap:anywhere;">${linkify(
          line,
        )}</div>`
      })
      .filter(Boolean)
      .join("")

    console.log(formattedReceipt)
    return formattedReceipt + imageBlock
  }

  return <div>{renderFallbackTicket(ticketData)}</div>
}

export default FallbackTicket
